import Text from 'components/design-system/Text/Text';
import { formatoFechaHora } from 'helpers/formatFecha';

export const DetalleDestinatarios = ({
  data,
  id,
  tipo,
  getEtiquetaEstado,
  getReenviarButton
}) => {
  return (
    <div className="p-4">
      <table className="w-full">
        <thead>
          <tr>
            <th className="w-1/5">
              <Text className="font-semibold text-black mb-2">
                Última actualización
              </Text>
            </th>
            <th className="w-1/5">
              <Text className="font-semibold text-black mb-2">Estado</Text>
            </th>
            <th className="w-3/5">
              <Text className="font-semibold text-black mb-2">
                {data[0] && data[0].destinatario.includes('@')
                  ? 'Emails'
                  : 'Negocio'}
              </Text>
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, key) => (
            <tr className="border-t" key={key}>
              <td className="w-1/5 py-1.5">
                <Text>{formatoFechaHora(item.fechaHoraSolicitud)}</Text>
              </td>
              <td className="w-1/5 py-1.5">
                {getEtiquetaEstado(item.estado.toUpperCase())}{' '}
                {getReenviarButton({ ...item, tipo: tipo }, id)}
              </td>
              <td className="w-3/5">
                <Text className="font-semibold text-black">
                  {item.destinatario}
                </Text>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
